import * as React from 'react';
import { FormControl } from "@common/components/form-control";
import { getTestAttributes } from '@common/utils/tests';
import { MODULE_NAME } from '@modules/fhq-design-tool/constants/shared';
import { Field, FieldError } from '../field';
import cx from 'classnames';
import { IInputComponent } from '@modules/fhq-design-tool/types/input-component';

import './text-field.styles.scss';

export type TextFieldProps = IInputComponent<string> & {
  inputWidth?: number | string;
  type?: 'string' | 'number' | 'textarea';
  labelWidth?: number;
  label?: string;
  errors?: Array<FieldError>;
  placeholder?: string;
  classes?: {
    label?: string;
    input?: string;
    labelInputWrapper?: string;
    errorText?: string;
  };
  min?: number;
  max?: number;
};

export const TextField: React.FC<TextFieldProps> = (props) => {
  const { inputWidth, classes, type, errors, className, disabled, label, labelWidth, onChange, value, metadata, description, required, margin, placeholder, min, max } = props;
  const [localValue, setLocalValue] = React.useState<string>('');

  React.useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value || '');
    }
  }, [value]);

  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalValue(e.target.value);
  }, []);

  const handleBlur = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  }, [onChange]);

  return (
    <Field 
      inputWidth={inputWidth}
      labelWidth={labelWidth} 
      label={label} 
      disabled={disabled}
      className={cx('FhqDesignToolTextField', className)}
      description={description}
      required={required}
      margin={margin}
      errors={errors}
      classes={{
        label: classes?.label,
        labelInputWrapper: classes?.labelInputWrapper,
        errorText: classes?.errorText
      }}
    >
      {type === 'textarea'
        ? (
          <textarea 
            {...getTestAttributes(MODULE_NAME, metadata.description, 'text-field', metadata.id)}
            className={cx('FhqDesignToolTextField__textarea', classes?.input)}
            rows={5}
            placeholder={placeholder}
            value={localValue} 
            onChange={handleChange as unknown as React.FormEventHandler<HTMLTextAreaElement>} 
            onBlur={handleBlur as unknown as React.FormEventHandler<HTMLTextAreaElement>}
            disabled={disabled} 
          />
        )
        : (
          <FormControl 
            {...getTestAttributes(MODULE_NAME, metadata.description, 'text-field')}
            className={classes?.input}
            placeholder={placeholder}
            type={type}
            value={localValue} 
            onChange={handleChange} 
            onBlur={handleBlur}
            disabled={disabled} 
            min={min}
            max={max}
          />
        )
      }
    </Field>
  );
};